import { CmtsAdminIdentityPage } from "../components/admin/index.js";
import { cmtsOrganizationUnitAdminIdentityConfig } from "../config/adminIdentity.config.js";

export function CmtsOrganizationUnitPage() {
  return <CmtsAdminIdentityPage config={cmtsOrganizationUnitAdminIdentityConfig} />;
}

export default CmtsOrganizationUnitPage;
